export default "__VITE_ASSET__CKbR8MrP__"